export default __webpack_public_path__ + "assets/fonts/BerninaSans-CompressedBold.bb8267bfed6a22a6a64a9eee58bcb7fe.otf";